const homeRouter = {
  name: 'Home',
  path: '/home',
  component: () => import('@/views/Home.vue'),
  children: [
    // {
    //   path: 'phone',
    //   name: 'PhonePage',
    //   component: () => import('@/page/Phone.vue')
    // },
    // {
    //   path: 'message',
    //   name: 'MessagePage',
    //   component: () => import('@/page/Message.vue')
    // },
    // {
    //   path: 'send',
    //   name: 'SendPage',
    //   component: () => import('@/page/Send.vue')
    // },
    {
      path: 'games-report',
      name: 'Games Report',
      component: () => import('@/views/GamesReport.vue')
    },
    {
      path: 'bet-list',
      name: 'Bet Order List',
      component: () => import('@/views/BetHistory.vue')
    },
    {
      path: 'amend-bet-order',
      name: 'Amend Order',
      component: () => import('@/views/AmendBetOrder.vue')
    },
    {
      path: 'rsg-calculator',
      name: 'RSG Calculator',
      component: () => import('@/views/RsgCalculator.vue')
    }
  ]
}

export default homeRouter
